import { render, staticRenderFns } from "./DropDowns.vue?vue&type=template&id=131bb08b&"
import script from "./DropDowns.vue?vue&type=script&lang=js&"
export * from "./DropDowns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports